export const setSpeechInstance = (state, speechInstance) => {
  state.speechInstance = speechInstance
}

export const setAvailableVoices = (state, availableVoices) => {
  state.availableVoices = availableVoices
}

export const startReading = (state) => {
  state.paused = false
  state.reading = true
}

export const endReading = (state) => {
  state.reading = false
  state.paused = false
}

export const pauseReading = (state) => {
  state.paused = true
}

export const resumeReading = (state) => {
  state.paused = false
}

export const setPlaylist = (state, playlist) => {
  state.playlist = playlist
  localStorage.setItem('playlist', JSON.stringify(playlist))
}

export const setCurrentIndex = (state, i) => {
  state.currentIndex = i
  localStorage.setItem('track', i)
}

export const setCurrentText = (state, string) => {
  state.currentText = string
}

export const setMarkerSpeech = (state, marker) => {
  state.markerSpeech = marker
  localStorage.setItem('speech', JSON.stringify(marker))
}
